import React from 'react'
import Layout from '../components/Layout'
import { BusinessZones } from '../components/Setting/BusinessZones'

export const BusinessZone = () => {
  return (
    <div>
      <Layout>
        <BusinessZones />
      </Layout>
    </div>
  )
}
